import { useState } from "react";
import {
  Box,
  Image,
  Stack,
  HStack,
  Text,
  useMediaQuery,
  Pressable,
} from "native-base";
import { Svg } from "react-native-svg";
import { COLORS } from "../../utils/colors";
import CommonBadge from "../../components/badge";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../utils/fonts";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import CustomModal from "../../components/modal";
import ImageViewer from "../../components/imageViewer";
import ImageViewerJs from "../../components/imageViewer/viewer";
import MobileModelSheet from "../../components/actionSheet";
import FileViewerComponent from "../../components/fileViewer";
import { downloadIconSVG, deleteCardsIconSVG } from "../../utils/svg";
import config from "../../utils/config";
import { setIsDownloading } from "../../store/reducers/eventSlice";
import { useDispatch } from "react-redux";
import { deleteWalletAPI } from "../../api/apis/quicklinks";
import { Toaster } from "../../components/toaster";
import CustomButton from "../../components/button";
import { LoaderAnimation } from "../../components/spinner";
import { hasPermission } from "../../utils/permission";
import CryptoJS from "crypto-js";

const Wallet = ({
  walletDetails = [],
  width = "328",
  columns = 5,
  activeTab = "",
  onWalletDelete = () => {},
  scrollToTop = () => {},
  addedBy = "",
}) => {
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const dispatch = useDispatch();
  const toaster = Toaster();
  const [showModal, setShowModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState("");

  // Get current user email
  const getCurrentUserEmail = () => {
    try {
      const content = sessionStorage.getItem("content");
      if (content) {
        const bytes = CryptoJS.AES.decrypt(content, config.userKey);
        const jsonString = bytes.toString(CryptoJS.enc.Utf8);
        const userInfo = JSON.parse(jsonString);
        return userInfo?.email || "";
      }
    } catch (error) {
      console.error('Error getting user email:', error);
    }
    return "";
  };

  // Check if user can delete wallet
  const canDeleteWallet = () => {
    if (!walletDetails?.wallet_id) return false;
    
    const currentUserEmail = getCurrentUserEmail();
    const isAdmin = hasPermission('ADMIN');
    const isOwner = currentUserEmail === addedBy;
    return isAdmin || isOwner;
  };

  const openModal = () => {
    !MobileWindow && scrollToTop();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedAction("");
    }, 300);
  };

  const handleDeleteWallet = async () => {
    if (walletDetails?.wallet_id) {
      try {
        LoaderAnimation.show();
        const res = await deleteWalletAPI(walletDetails.wallet_id);
        LoaderAnimation.hide();
        if (res.error) {
          toaster(res.message, "error", "error");
        } else {
          toaster(res?.data?.data?.data || "Wallet deleted successfully", "success", "success");
          onWalletDelete();
        }
      } catch (error) {
        LoaderAnimation.hide();
        toaster("Error deleting wallet", "error", "error");
      }
    }
    closeModal();
  };

  const getModalHeader = () => {
    if (selectedAction === "delete_wallet") {
      return <>Delete Wallet</>;
    }
    return (
      <HStack
        justifyContent={"space-between"}
        width={MobileWindow ? "90%" : "95%"}
      >
        <Text width={MobileWindow && "100%"}>
          {walletDetails.document_name}
        </Text>

        <Pressable
          onPress={() => {
            dispatch(setIsDownloading(true));
            // const parts =
            //   config.bucketPath + walletDetails.file_name?.split("_");
            // const filename = parts.slice(1).join("_").trim();
            // const sanitizedFilename = filename.replace(
            //   /^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+$/g,
            //   ""
            // );

            fetch(config.bucketPath + walletDetails.file_name)
              .then((response) => response.blob())
              .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = walletDetails.document_name;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
              })
              .catch((error) => {
                console.error("Error downloading file:", error);
              });
            dispatch(setIsDownloading(false));
          }}
        >
          <Box mt={MobileWindow && 1}>
            {/* <i
              className="fa fa-download pointer"
              style={{ color: "black" }}
            ></i> */}
            <Svg width="50" height="40" viewBox="0 0 1 36">
              {downloadIconSVG}
            </Svg>
          </Box>
        </Pressable>
      </HStack>
    );
  };

  const getModalChildren = () => {
    if (selectedAction === "delete_wallet") {
      return (
        <Box justifyContent={"center"} alignItems={"center"}>
          <Text
            fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
            fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          >
            Are you sure, want to delete this wallet?
          </Text>
        </Box>
      );
    }
    const extension = walletDetails.file_name?.split(".").pop();
    return extension === "png" ||
      extension === "jpeg" ||
      extension === "jpg" ? (
      <ImageViewer path images={[{ file_name: walletDetails.file_name }]} />
    ) : (
      <FileViewerComponent
        path={config.bucketPath + walletDetails.file_name}
        height="68vh"
      />
    );
  };

  const handleWalletCategory = () => {
    if (
      walletDetails.category === "mice" ||
      (walletDetails.category === "" && activeTab === "mice")
    )
      return "MICE";
    else if (
      walletDetails.category === "event" ||
      (walletDetails.category === "" && activeTab === "event")
    )
      return "Event";
    else if (walletDetails.category === "general") return "General";
  };

  return (
    <Box
      width={MobileWindow ? "100%" : "calc(100% / 4 - 20px)"}
      mb={MobileWindow ? 4 : 5}
      px={MobileWindow && 2}
    >
      <Box
        maxW="100%"
        borderBottomRadius="lg"
        overflow="hidden"
        border="none"
        filter="drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.05))"
      >
        <Box>
          <Image
            source={{
              uri: require("../../utils/quickLinkImages/Wallet_Rectangle 26987 (1).png"),
            }}
            alt="image"
            width={"100%"}
            height={"160px"}
          />
        </Box>
        <Stack p="2" space={3} bg={COLORS.WHITE_COLOR}>
          <HStack justifyContent={"space-between"}>
            <Stack space={2} width={"94%"}>
              {walletDetails && walletDetails.event_id && (
                <Text
                  px={2}
                  fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
                  fontSize={COMMONFONTSIZE.MEDIUM_FONT_SIZE}
                >
                  {walletDetails.event_id}
                </Text>
              )}
              <Text px={2} color={COLORS.ATTACHMENTS_TEXT_COLOR}>
                {walletDetails.document_name}
              </Text>
              <HStack pb={2} pl={2}>
                <CommonBadge
                  text={walletDetails.document_name && handleWalletCategory()}
                  closebtn={false}
                  colorScheme={COLORS.WALLET_BADGE_COLOR}
                  textColor={COLORS.ATTACHMENTS_TEXT_COLOR}
                  fontSize={COMMONFONTSIZE.SMALL_FONT_SIZE}
                />
              </HStack>
            </Stack>
            <HStack alignItems="center" justifyContent="center" space={4} ml={-12}>
              {/* Delete icon for all wallet items */}
              {walletDetails.wallet_id && canDeleteWallet() && (
                <Pressable
                  onPress={() => {
                    openModal();
                    setSelectedAction("delete_wallet");
                  }}
                >
                  <Box mt={3} width={MobileWindow && "15%"}>
                    <Svg width="24" height="20" viewBox="0 0 24 24">
                      {deleteCardsIconSVG}
                    </Svg>
                  </Box>
                </Pressable>
              )}
              {/* Image viewer for images OR download for documents */}
              {walletDetails.file_name?.split(".").pop() === "png" ||
              walletDetails.file_name?.split(".").pop() === "jpg" ||
              walletDetails.file_name?.split(".").pop() === "jpeg" ? (
                <Pressable>
                  <Box mt={7} mr={4} width={"30%"}>
                    <ImageViewerJs
                      src={config.bucketPath + walletDetails.file_name}
                    />
                  </Box>
                </Pressable>
              ) : (
                <Pressable
                  onPress={() => {
                    if (walletDetails.file_name?.split(".").pop() !== "zip") {
                      setSelectedAction("view_file");
                      openModal();
                    }
                  }}
                >
                  <Box mt={7} mr={4} width={MobileWindow && "30%"}>
                  {/* <i className="fa fa-download pointer"></i> */}
                    <Svg width="50" height="40" viewBox="25 0 1 36">
                      {downloadIconSVG}
                    </Svg>
                  </Box>
                </Pressable>
              )}
            </HStack>
          </HStack>
        </Stack>
        {!MobileWindow ? (
          <CustomModal
            size=""
            isOpen={showModal}
            onClose={closeModal}
            header={getModalHeader()}
            body={showModal && getModalChildren()}
            footer={selectedAction === "delete_wallet" ? (
              <Box width="100%" alignItems="flex-end">
                <CustomButton
                  onPress={handleDeleteWallet}
                  text="Confirm"
                  color={COLORS.WHITE_COLOR}
                />
              </Box>
            ) : null}
            width={
              selectedAction === "delete_wallet"
                ? "40%"
                : walletDetails.file_name?.split(".").pop() === "png" ||
                  walletDetails.file_name?.split(".").pop() === "jpg" ||
                  walletDetails.file_name?.split(".").pop() === "jpeg" ||
                  selectedAction === "view_file"
                ? "fit-content"
                : "90%"
            }
            height={
              selectedAction === "view_file"
                ? "80vh"
                : selectedAction === "delete_wallet" ||
                  walletDetails.file_name?.split(".").pop() === "png" ||
                  walletDetails.file_name?.split(".").pop() === "jpg" ||
                  walletDetails.file_name?.split(".").pop() === "jpeg"
                ? "fit-content"
                : "80vh"
            }
            fixedPosition={selectedAction === "delete_wallet" || selectedAction === "view_file" ? false : true}
          />
        ) : (
          <MobileModelSheet
            isOpen={showModal}
            onClose={closeModal}
            header={getModalHeader()}
            body={showModal && getModalChildren()}
            footer={selectedAction === "delete_wallet" ? (
              <Box width="100%" alignItems="flex-end">
                <CustomButton
                  onPress={handleDeleteWallet}
                  text="Confirm"
                  color={COLORS.WHITE_COLOR}
                />
              </Box>
            ) : null}
            maxH={"80vh"}
            position="hidden"
          />
        )}
      </Box>
    </Box>
  );
};

export default Wallet;
